import AdminMenu from './AdminMenu';

export default AdminMenu;



// WEBPACK FOOTER //
// ./src/components/AdminMenu/index.jsx